import Vue from 'vue'
import VueRouter from 'vue-router'
import Axios from 'axios'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'

import './assets/css/wx_common.css'
import './assets/css/wx_style.css'

Vue.use(VueRouter)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/loading.jpg',
  loading: 'dist/loading.jpg',
  attempt: 1,
  listenEvents: [ 'scroll', 'mousewheel','touchmove' ]
})

Vue.prototype.$http = Axios

import routerConfig from './router.config.js'
const router = new VueRouter(routerConfig)

new Vue({
  router,
  el: '#app',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js